import config from 'config'

const receiptConfig = {
  receiptBaseUrl: config.resourceHost,
  expense: {
    receipt: `${config.resourceHost}expense/receipt`,
  },
  revenue: {
    receipt: `${config.resourceHost}revenue/receipt`,
  },
}

export default receiptConfig
